module.exports = __webpack_public_path__ + "img/dianchi-20.32ba5757.svg";